import { memo } from 'react';
import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { CheckoutConfirmationTable } from 'src/pages/Checkout/components/common/Table';
import { commonFormatCurrencyWithType } from 'src/utils/currency';

type Props = {
  model: CheckoutConfirmationResponseType['RaffleTicketsSubSection'];
};

export const CheckoutConfirmationRaffleTickets = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.tickets');

  const ticketsSingular = model.TicketsTerminology.Singular || '';

  const columns = [
    { name: ticketsSingular, className: 'left ticket-name' },
    model.ShowPrizeColumn && { name: model.PrizeTerminology.Singular || '' },
    { name: tHelper('numbers', { singular: ticketsSingular }), className: 'left ticket-numbers' },
    { name: tHelper('quantity'), className: 'align-center' },
    { name: tHelper('amount'), className: 'right' },
  ];

  return (
    <>
      <h2 className="section-header">{model.SectionHeader}</h2>
      <CheckoutConfirmationTable columns={columns} data={model.Items}>
        {(item) => (
          <>
            <td className="left">{item.ItemTitle}</td>
            {model.ShowPrizeColumn && <td>{item.PrizeTitle}</td>}
            <td className="left">{item.TicketNumbers}</td>
            <td className="align-center">{item.Quantity}</td>
            <td className="right">
              {item.Amount ? commonFormatCurrencyWithType(item.Amount, model.CurrencyType) : tHelper('free')}
            </td>
          </>
        )}
      </CheckoutConfirmationTable>
    </>
  );
});
